import { render, staticRenderFns } from "./switchTab.vue?vue&type=template&id=130fd972&scoped=true&"
import script from "./switchTab.vue?vue&type=script&lang=js&"
export * from "./switchTab.vue?vue&type=script&lang=js&"
import style0 from "./switchTab.vue?vue&type=style&index=0&id=130fd972&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130fd972",
  null
  
)

export default component.exports